/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConfirmInputs */

const en_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const ar_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأكيد`)
};

const de_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const es_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const it_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

const ja_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

const ko_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

const pt_br_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const ru_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить`)
};

const th_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยัน`)
};

const tr_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onayla`)
};

const zh_cn_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认`)
};

const zh_tw_confirm = /** @type {(inputs: ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {ConfirmInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const confirm = /** @type {((inputs?: ConfirmInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConfirmInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm(inputs)
	if (locale === "ar") return ar_confirm(inputs)
	if (locale === "de") return de_confirm(inputs)
	if (locale === "es") return es_confirm(inputs)
	if (locale === "fr") return fr_confirm(inputs)
	if (locale === "it") return it_confirm(inputs)
	if (locale === "ja") return ja_confirm(inputs)
	if (locale === "ko") return ko_confirm(inputs)
	if (locale === "pt_br") return pt_br_confirm(inputs)
	if (locale === "ru") return ru_confirm(inputs)
	if (locale === "th") return th_confirm(inputs)
	if (locale === "tr") return tr_confirm(inputs)
	if (locale === "zh_cn") return zh_cn_confirm(inputs)
	return zh_tw_confirm(inputs)
});